module.exports = __webpack_public_path__ + "static/media/mask-group.bb6a0493.png";